import { render, staticRenderFns } from "./AiScoreView.vue?vue&type=template&id=21f95d08&scoped=true"
import script from "./AiScoreView.vue?vue&type=script&lang=js"
export * from "./AiScoreView.vue?vue&type=script&lang=js"
import style0 from "./AiScoreView.vue?vue&type=style&index=0&id=21f95d08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f95d08",
  null
  
)

export default component.exports